// Theme JavaScript
(function () {
  "use strict";

  // Prevent automatic scrolling on page load
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  // DOM elements
  const header = document.querySelector(".header");
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const cartCount =
    document.querySelector("[data-cart-count]") ||
    document.querySelector(".header__cart-count") ||
    document.querySelector(".cart-count");

  function setCartCount(count) {
    if (!cartCount || typeof count !== "number" || Number.isNaN(count)) {
      return;
    }

    cartCount.textContent = count;
    cartCount.classList.toggle("hidden", count === 0);
  }

  function animateCartCount() {
    if (!cartCount) {
      return;
    }

    cartCount.classList.add("animate");
    setTimeout(() => {
      cartCount.classList.remove("animate");
    }, 300);
  }

  function incrementCartCount(delta) {
    if (!cartCount || typeof delta !== "number" || Number.isNaN(delta)) {
      return;
    }

    const current = parseInt(cartCount.textContent, 10);
    const currentCount = Number.isNaN(current) ? 0 : current;
    const nextCount = Math.max(currentCount + delta, 0);
    setCartCount(nextCount);
    animateCartCount();
  }

  function getQuantityFromFormData(formData) {
    const quantity = parseInt(formData.get("quantity"), 10);
    return Number.isNaN(quantity) ? 1 : quantity;
  }

  function showAddToCartSuccess({ productTitle, variantTitle }) {
    const normalizedProductTitle = productTitle || "Product";
    const normalizedVariantTitle =
      variantTitle && variantTitle !== "Default Title" ? variantTitle : "";

    const existingNotification = document.querySelector(".add-to-cart-success");
    if (existingNotification) {
      existingNotification.remove();
    }

    const notification = document.createElement("div");
    notification.className = "add-to-cart-success";

    const content = document.createElement("div");
    content.className = "add-to-cart-success__content";

    const icon = document.createElement("div");
    icon.className = "add-to-cart-success__icon";
    icon.textContent = "✓";

    const textWrapper = document.createElement("div");
    textWrapper.className = "add-to-cart-success__text";

    const title = document.createElement("div");
    title.className = "add-to-cart-success__title";
    title.textContent = "Added to cart!";

    const message = document.createElement("div");
    message.className = "add-to-cart-success__message";

    const product = document.createElement("strong");
    product.textContent = normalizedProductTitle;
    message.appendChild(product);

    if (normalizedVariantTitle) {
      message.appendChild(document.createElement("br"));
      message.appendChild(
        document.createTextNode(
          `${normalizedVariantTitle} has been added to your cart.`
        )
      );
    } else {
      message.appendChild(
        document.createTextNode(" has been added to your cart.")
      );
    }

    textWrapper.appendChild(title);
    textWrapper.appendChild(message);

    const closeButton = document.createElement("button");
    closeButton.className = "add-to-cart-success__close";
    closeButton.setAttribute("aria-label", "Close notification");
    closeButton.textContent = "\u00D7";

    content.appendChild(icon);
    content.appendChild(textWrapper);
    content.appendChild(closeButton);
    notification.appendChild(content);

    document.body.appendChild(notification);

    requestAnimationFrame(() => {
      notification.classList.add("is-visible");
    });

    const hideNotification = () => {
      notification.classList.remove("is-visible");
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    };

    const autoHideTimer = setTimeout(hideNotification, 4000);

    closeButton.addEventListener("click", () => {
      clearTimeout(autoHideTimer);
      hideNotification();
    });

    return notification;
  }

  // Calculate and set body padding based on header height
  function adjustBodyPadding() {
    if (header) {
      // Get the complete header height including the scrolling text bar
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = headerHeight + "px";

      // Also update the mobile menu position if it exists
      const mobileMenu = document.querySelector("#mobile-menu");
      if (mobileMenu) {
        mobileMenu.style.top = headerHeight + "px";
        mobileMenu.style.height = `calc(100% - ${headerHeight}px)`;
      }
    }
  }

  // Call on page load
  adjustBodyPadding();

  // Recalculate on window resize
  window.addEventListener("resize", adjustBodyPadding);

  // Recalculate when scrolling text is toggled (via theme editor)
  document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId.includes("header")) {
      adjustBodyPadding();
    }
  });

  // Mobile menu functionality
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("click", function () {
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  // Sticky header - header will now remain visible at all times
  // The CSS position: sticky will handle the stickiness
  /* Remove the scroll-based hiding behavior
  let lastScrollTop = 0;
  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      header.classList.add("is-hidden");
    } else {
      header.classList.remove("is-hidden");
    }

    lastScrollTop = scrollTop;
  });
  */

  // Cart functionality
  function updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let cleanCount = 0;
        if (cart.items && Array.isArray(cart.items)) {
          cart.items.forEach((item) => {
            let isSpecial = false;
            const title = item.title || "";
            if (
              title.includes("Refundable Credit Card") ||
              title.includes("Picking &") ||
              title.includes("Non-Member") ||
              title.includes("Non Member")
            ) {
              isSpecial = true;
            }
            if (item.properties && item.properties._gb_fee) {
              isSpecial = true;
            }
            if (!isSpecial) {
              cleanCount += item.quantity;
            }
          });
        }
        setCartCount(cleanCount);
      })
      .catch((error) => console.error("Error:", error));
  }

  // Initialize cart count
  updateCart();

  // Listen for cart updates
  document.addEventListener("cart:updated", updateCart);

  // Product Card functionality
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector(".product-card__form");
      this.quantityInput = this.querySelector(".quantity-input");
      this.decreaseButton = this.querySelector('[data-action="decrease"]');
      this.increaseButton = this.querySelector('[data-action="increase"]');
      this.addToCartButton = this.querySelector(".add-to-cart-button");
      this.productTitle =
        this.dataset.productTitle?.trim() ||
        this.querySelector(".product-card__title a")?.textContent?.trim() ||
        "";
      this.variantTitle = this.dataset.variantTitle?.trim() || "";

      this.init();
    }

    init() {
      if (this.quantityInput && this.decreaseButton && this.increaseButton) {
        this.decreaseButton.addEventListener("click", () =>
          this.updateQuantity("decrease")
        );
        this.increaseButton.addEventListener("click", () =>
          this.updateQuantity("increase")
        );
        this.quantityInput.addEventListener("change", () =>
          this.validateQuantity()
        );
      }

      if (this.form) {
        this.form.addEventListener("submit", (event) =>
          this.handleAddToCart(event)
        );
      }
    }

    updateQuantity(action) {
      const currentValue = parseInt(this.quantityInput.value);

      if (action === "decrease" && currentValue > 1) {
        this.quantityInput.value = currentValue - 1;
      } else if (action === "increase") {
        this.quantityInput.value = currentValue + 1;
      }

      this.validateQuantity();
    }

    validateQuantity() {
      const value = parseInt(this.quantityInput.value);
      if (isNaN(value) || value < 1) {
        this.quantityInput.value = 1;
      }
    }

    handleAddToCart(event) {
      event.preventDefault();

      if (!this.addToCartButton.disabled) {
        const formData = new FormData(this.form);
        const quantityToAdd = getQuantityFromFormData(formData);
        const variantId = formData.get('id');
        const noteRaw = formData.get('properties[Note]');
        const noteValue = noteRaw ? String(noteRaw).trim() : '';

        fetch("/cart.js")
          .then((r) => r.json())
          .then((cart) => {
            const existingItem = cart.items.find((i) => 
              i.variant_id.toString() === variantId.toString() && 
              ((i.properties && i.properties.Note) || '') === noteValue
            );

            if (existingItem) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: existingItem.key,
                  quantity: existingItem.quantity + quantityToAdd
                })
              });
            } else {
              return fetch("/cart/add.js", {
                method: "POST",
                body: formData,
              });
            }
          })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.status && data.status !== 200) {
              const errorMessage =
                data.message || data.description || "Error adding to cart";
              throw new Error(errorMessage);
            }

            incrementCartCount(quantityToAdd);
            showAddToCartSuccess({
              productTitle: this.productTitle,
              variantTitle: this.variantTitle,
            });
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh")
            );
            // Trigger cart update event
            document.dispatchEvent(new CustomEvent("cart:updated"));

            // Show success message
            const originalText = this.addToCartButton.textContent;
            this.addToCartButton.textContent = "Added!";
            this.addToCartButton.disabled = true;

            // Reset button after 2 seconds
            setTimeout(() => {
              this.addToCartButton.textContent = originalText;
              this.addToCartButton.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error("Error:", error);
            this.addToCartButton.textContent = "Error adding to cart";
            setTimeout(() => {
              this.addToCartButton.textContent = "Add to cart";
            }, 2000);
          });
      }
    }
  }

  // Register the ProductCard custom element
  if (!customElements.get("product-card")) {
    customElements.define("product-card", ProductCard);
  }

  // Product form submission
  const productForms = Array.from(
    document.querySelectorAll('form[action="/cart/add"]')
  ).filter(
    (form) =>
      !form.closest("product-card") &&
      !form.closest("product-form") &&
      !form.classList.contains("product-form")
  );

  productForms.forEach((form) => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const formData = new FormData(form);
      const quantityToAdd = getQuantityFromFormData(formData);
      const variantId = formData.get('id');
      const noteRaw = formData.get('properties[Note]');
      const noteValue = noteRaw ? String(noteRaw).trim() : '';

      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          const existingItem = cart.items.find((i) => 
            i.variant_id.toString() === variantId.toString() && 
            ((i.properties && i.properties.Note) || '') === noteValue
          );

          if (existingItem) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: existingItem.key,
                quantity: existingItem.quantity + quantityToAdd
              })
            });
          } else {
            return fetch("/cart/add.js", {
              method: "POST",
              body: formData,
            });
          }
        })
        .then((response) => response.json())
        .then((item) => {
          if (item && item.status && item.status !== 200) {
            const errorMessage =
              item.message || item.description || "Error adding to cart";
            throw new Error(errorMessage);
          }

          incrementCartCount(quantityToAdd);
          updateCart();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh")
          );
          // Trigger mini cart open or show success message
        })
        .catch((error) => console.error("Error:", error));
    });
  });

  // Initialize any product carousels
  const productCarousels = document.querySelectorAll(".product-carousel");
  if (productCarousels.length > 0) {
    productCarousels.forEach((carousel) => {
      // Add your carousel initialization here
      // Example: new ProductCarousel(carousel);
    });
  }

  // Handle quick view buttons
  const quickViewButtons = document.querySelectorAll(".quick-view-button");
  quickViewButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const productUrl = this.getAttribute("data-product-url");

      fetch(productUrl + "?view=quick-view")
        .then((response) => response.text())
        .then((html) => {
          // Add your quick view modal implementation here
        })
        .catch((error) => console.error("Error:", error));
    });
  });
})();
